<template lang="pug">
  v-container(class="pa-15")
      v-dialog(v-model='showCancelDialog' persistent='' max-width='400px')
        v-card
          v-card-title
            span.headline Cancelar solicitud
          v-card-text
            v-container
              v-row
                p Escriba la razon para cancelar la solicitud
                v-textarea(label='razon de cancelacion' v-model="txtMotive")
          v-card-actions
            v-spacer
            v-btn(color='primary darken-1' text='' @click='showCancelDialog = false') No
            v-btn(color='primary darken-1' text='' @click='cancelWithdraw()') Si
      v-dialog(v-model='showCancelReasonDialog' max-width='400px')
        v-card
          v-card-title
            span.headline Razon de cancelacion
          v-card-text
            | {{selectedWithdraw.cancelMotive}}
          v-card-actions
            v-spacer
            v-btn(color='primary' text='' @click='showCancelReasonDialog = false') cerrar
      v-row(align="center" justify="center")
        v-text-field(label="Email" required :rules="emailRules" type="text" v-model="email")
        v-btn(class="ml-2" color='primary' :disabled="(email === '' ? true : false) || loading" @click="searchUserWithdrawalHistory()") buscar cliente
      h2 {{ 'Historial de solicitudes de retiro ' + userFullName }}
      v-progress-linear(v-if="loading" indeterminate="" color="primary")
      v-data-table.elevation-1(:headers="headers" :items="withdraws" :items-per-page="15"  max-width='800')
          template(v-slot:item.actions="{ item }")
                  v-btn(v-on='on' v-if="item.status === 'pendiente'" icon='' color='green' @click="confirmationWithdraw(item)")
                    v-icon mdi-check
                  v-btn(v-on='on' v-if="item.status === 'pendiente'" icon='' color='red' @click="selectWithdrawToCancel(item)")
                    v-icon mdi-close
                  v-btn(v-on='on' v-if="item.status === 'cancelada'" icon='' color='primary' @click="openCancelReasonDialog(item)")
                    v-icon mdi-eye
      v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
          | {{ snackbar.text }}
          v-btn(dark='' text='' @click='snackbar.snackbar = false')
            | {{$t('payment.general.close')}}
</template>

<script>
  import ReferralsCard from '@/components/custom/ReferralsCard'

  export default {
    components: {
      ReferralsCard: ReferralsCard,
    },
    data () {
      return {
        headers: [
          { text: 'Fecha(dia/mes/año)', value: 'requestDay' },
          { text: 'Email de paypal', value: 'accountNumber' },
          { text: 'Monto', value: 'amount' },
          { text: 'Estado', value: 'status' },
          { text: 'Acciones', value: 'actions' },
        ],
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 10000,
        },
        emailRules: [
          v => !!v || 'Ingrese un email',
        ],
        withdraws: [],
        showCancelDialog: false,
        email: '',
        userFullName: '',
        showCancelReasonDialog: false,
        loading: false,
        selectedWithdraw: {},
        txtMotive: '',
      }
    },
    methods: {
      confirmationWithdraw (item) {
        // console.log(item)
        const withdrawData = {
          withdraw: item,
          action: 'acepted',
        }
        this.$store.dispatch('referrals/aceptCancelWithdrawRequestsAdmin', withdrawData).then(res => {
          // console.log(res)
          const index = this.withdraws.indexOf(item)
          if (index > -1) {
            this.withdraws.splice(index, 1)
          }
        })
      },
      cancelWithdraw () {
        // cancelar con selectedWithdraw
        // console.log(this.txtMotive)
        if (this.txtMotive !== '') {
          const withdrawData = {
            withdraw: this.selectedWithdraw,
            action: 'canceled',
            motive: this.txtMotive,
          }
          this.showCancelDialog = false
          this.$store.dispatch('referrals/aceptCancelWithdrawRequestsAdmin', withdrawData).then(res => {
            // console.log(res)
            this.setDataNotification(true, 'success', 'Solicitud ha sido cancelada')
            const index = this.withdraws.indexOf(this.selectedWithdraw)
            if (index > -1) {
              this.withdraws.splice(index, 1)
            }
          })
        } else {
          // console.log('entre')
          this.setDataNotification(true, 'error', 'La solicitud debe contener una razon de cancelacion.')
        }
      },
      selectWithdrawToCancel (item) {
        this.showCancelDialog = true
        this.selectedWithdraw = item
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      openCancelReasonDialog (withdraw) {
        this.showCancelReasonDialog = true
        this.selectedWithdraw = withdraw
      },
      searchUserWithdrawalHistory () {
        this.loading = true
        const withdrawData = {
          userEmail: this.email,
          isAdmin: true,
        }
        this.$store.dispatch('referrals/getWithdrawRequests', withdrawData).then(res => {
          // console.log(res)
          this.loading = false
          if (res) {
            if (res.userFullName) {
              this.userFullName = res.userFullName
              this.withdraws = res.withdraws.reverse()
            } else {
              this.setDataNotification(true, 'error', 'Cliente no encontrado')
            }
          }
        })
      },
    },
  }
</script>
